/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Named closed caption configuration sets the user selects from. Each preset
 * maps to a complete {TClosedCaptionStyle} in {CLOSED_CAPTION_PRESETS}; the
 * user picks a preset rather than individual style parameters.
 *
 * Additional presets are added here and in the preset registry as the final
 * caption configurations are defined.
 */
export enum ClosedCaptionPreset {
  Default = "default",
  HighContrast = "highContrast",
  LargeYellow = "largeYellow"
}
